<img src="assets/img/{{src}}/{{src}}.png"
srcset="/assets/img/{{src}}/{{src}}@2x.png 2x, /assets/img/{{src}}/{{src}}@3x.png 3x">
